export const getTranslation = (file, language, key) => {
    return file[language]?.[key] || key;
};

export const indexLanguages = {
  en: {
    "AssignmentHistory": "Assignment History",
    "Close": "Close",
    "AssignedToAgent": "Assigned to agent",
    "On": "on",
    "ContactHasNoAssignments": "Contact has no assignments.",
    "ByAPIIntegration": "by API integration",
    "ByAdminUser": "by Admin user",
    "ByAgentUser": "by Agent user",
    "ByAutomaticAssignment": "by automatic assignment",
    "ByChatbot": "by chatbot",
    "ByAPI": "by API",
    "WithID": "with ID",
    "AssignedTo": "Assigned to",
    "AssignedBy": "Assigned by",
    "AssignmentDate": "Assignment date",
    "UnassignedBy": "Unassigned by",
    "UnassignmentDate": "Unassignment date",
    "NoAssignmentHistory": "No assignment history",
    "AssignedToTeam": "Assigned to team",
    "AssignedToAgent": "Assigned to agent",
    "TeamAssignment": "Team assignment",
    "AgentAssignment": "Agent assignment",
    "AgentTeamAssignment": "Agent in team"
  },
  es: {
    "AssignmentHistory": "Historial Asignaciones",
    "Close": "Cerrar",
    "AssignedToAgent": "Asignado al agente",
    "On": "en",
    "ContactHasNoAssignments": "Contacto no ha tenido asignaciones.",
    "ByAPIIntegration": "por API integración",
    "ByAdminUser": "por usuario Admin",
    "ByAgentUser": "por usuario Agente",
    "ByAutomaticAssignment": "por asignación automática",
    "ByChatbot": "por chatbot",
    "ByAPI": "por API",
    "WithID": "con ID",
    "AssignedTo": "Asignado a",
    "AssignedBy": "Asignado por",
    "AssignmentDate": "Fecha de asignación",
    "UnassignedBy": "Desasignado por",
    "UnassignmentDate": "Fecha de desasignación",
    "NoAssignmentHistory": "Sin historial de asignaciones",
    "AssignedToTeam": "Asignado al equipo",
    "AssignedToAgent": "Asignado al agente",
    "TeamAssignment": "Asignación de equipo",
    "AgentAssignment": "Asignación de agente",
    "AgentTeamAssignment": "Agente en equipo"
  },
  pt: {
    "AssignmentHistory": "Histórico de Atribuições",
    "Close": "Fechar",
    "AssignedToAgent": "Atribuído ao agente",
    "On": "em",
    "ContactHasNoAssignments": "O contato não tem atribuições.",
    "ByAPIIntegration": "por integração API",
    "ByAdminUser": "por usuário Admin",
    "ByAgentUser": "por usuário Agente",
    "ByAutomaticAssignment": "por atribuição automática",
    "ByChatbot": "por chatbot",
    "ByAPI": "por API",
    "WithID": "com ID",
    "AssignedTo": "Atribuído a",
    "AssignedBy": "Atribuído por",
    "AssignmentDate": "Data de atribuição",
    "UnassignedBy": "Desatribuído por",
    "UnassignmentDate": "Data de desatribuição",
    "NoAssignmentHistory": "Nenhum histórico de atribuições",
    "AssignedToTeam": "Atribuído à equipe",
    "AssignedToAgent": "Atribuído ao agente",
    "TeamAssignment": "Atribuição de equipe",
    "AgentAssignment": "Atribuição de agente",
    "AgentTeamAssignment": "Agente na equipe"
  }
};
